module.exports = __webpack_public_path__ + "img/download.be402d00.svg";